import {useState} from "react";
import Accordion from "./Accordion";


interface AccordionData {
  id: string,
  title: string,
  answer: string,
}

const FAQ = () => {
  const [openAccordion, setAccordionOpen] = useState<string | null>(null);

  const accordionData: AccordionData[] = [
    { id: "1", title: "What is PEPE3D?", answer: "PEPE3D is the pioneering multichain meme token, featuring Pepe the Frog, expanding its presence across major blockchains." },
    { id: "2", title: "How do I participate in the presale?", answer: "You can take part in the presale on BNB Chain. All you need to do is connect your wallet to the presale widget above and send BNB or USDT to reserve $PEPE3D tokens." },
    { id: "3", title: "When do I receive my presale tokens?" , answer: "Once you’ve completed your presale purchase, you’ll be able to use the same wallet to claim your tokens before the first DEX listing. Claim and listing dates will be announced on our social media accounts."},
    { id: "4", title: "Is there a way to contact support?", answer: "We’re here to help! Kindly join our Telegram channel to find prompt support from a PEPE3D moderator. You could also email contact@pepe3d.live and await a response." },
  ];

  return (
    <div className="w-2/3 p-4 bg-slate-950/80 rounded-lg">
    {accordionData.map(({ id, title, answer }: {id:string, title:string, answer:string }) => (
        <Accordion
          key={id}
          id={id}
          title={title}
          answer={answer}
          openAccordion={openAccordion}
          setAccordionOpen={setAccordionOpen}
        />
      ))}
    </div>
  );
};

export default FAQ;